import React, { useState } from 'react';
import { userApi } from '../api/axios';
import { Message } from './charte/Elements';

/* Renvoi du lien de confirmation d'adresse : POST /user/client-verify/renvoi
   (user-service, a370081). Le serveur répond toujours 202, que l'adresse ait
   un compte ou non, et n'envoie qu'un courriel toutes les 10 minutes par
   compte : le message ne promet donc rien de plus. */
const RenvoiConfirmation: React.FC<{ emailInitial?: string; id?: string }> = ({ emailInitial = '', id = 'renvoi-email' }) => {
  const [email, setEmail] = useState(emailInitial);
  const [envoi, setEnvoi] = useState(false);
  const [resultat, setResultat] = useState<{ genre: 'succes' | 'erreur'; texte: string } | null>(null);

  const renvoyer = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setResultat({ genre: 'erreur', texte: 'Saisissez une adresse email valide.' });
      return;
    }
    setEnvoi(true);
    setResultat(null);
    try {
      await userApi.post('/user/client-verify/renvoi', { email: email.trim() });
      setResultat({
        genre: 'succes',
        texte: `Si un compte non confirmé existe pour ${email.trim()}, un nouveau lien vient d'y être envoyé. `
          + "Pensez aux courriers indésirables. Un seul envoi est possible toutes les 10 minutes.",
      });
    } catch (err: any) {
      setResultat({ genre: 'erreur', texte: err?.response
        ? "Le lien n'a pas pu être renvoyé. Réessayez dans quelques minutes, ou écrivez à contact@tribe.sn."
        : 'Impossible de joindre Tribe. Vérifiez votre connexion puis réessayez.' });
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <form onSubmit={renvoyer} className="pile pile--serree" style={{ textAlign: 'left' }}>
      <div className="champ">
        <label htmlFor={id}>Adresse email du compte</label>
        <input id={id} type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} />
      </div>
      <button type="submit" className="bouton bouton--secondaire" disabled={envoi}>
        {envoi ? 'Envoi…' : 'Recevoir un nouveau lien de confirmation'}
      </button>
      {resultat && <Message genre={resultat.genre}>{resultat.texte}</Message>}
    </form>
  );
};

export default RenvoiConfirmation;
